import { useEffect } from 'react';

import Grid from '@mui/material/Grid2';
import { Card, Typography } from '@mui/material';

import { useTranslate } from 'src/locales';
import { useMicroSoftAuthPopup } from 'src/hook/useMicroSoftAuthPopup';

import { Step1 } from './step1';
import { Step2 } from './step2';
import { Step3 } from './step3';
import { Step4 } from './step4';
import { useChannelContext } from '../hooks';
import { ChannelSteps } from './channel-steps';
import VoiceStep1 from './voice-steps/voiceStep1';
import VoiceStep2 from './voice-steps/voiceStep2';
import { EmailSMTP } from './email-steps/EmailSMTP';
import { EmailIMAP } from './email-steps/EmailIMAP';
import { EmailStep3 } from './email-steps/email-step3';
import { EmailStep2 } from './email-steps/email-step2';
import { EmailStep5 } from './email-steps/email-step5';
import LiveChatStep1 from './liveChat-steps/liveChatStep1';

// ----------------------------------------------------------------------

export function ChannelStepView() {
  const { t } = useTranslate('translation');

  const {
    steps,
    activeStep,
    handleStepHeader,
    state: channelState,
    isLoading,
  } = useChannelContext();
  const { channelType, emailProviderType } = channelState;

  const { handleMicrosoftAuthRedirect } = useMicroSoftAuthPopup();

  const renderEmailSteps = (activeStp: number | null) => {
    // (3) => SMTP page : Add Users
    // (4) => IMAP page : Finish
    // (5) => Add Users
    // (6) => Finish
    // (7) => Get Email Address

    switch (activeStp) {
      case 1 /* Choose Email Provider */:
        return <EmailStep2 />;
      case 2 /* Add Channel and Verify Email */:
        return <EmailStep3 />;
      case 3 /* SMTP page || Add Users */:
        return emailProviderType === 'other_provider' ? <EmailSMTP /> : <Step3 />;
      case 4 /* IMAP page || Finish */:
        return emailProviderType === 'other_provider' ? <EmailIMAP /> : <Step4 />;
      case 5 /* (other_provider) Add Users */:
        return <Step3 />;
      case 6 /* (other_provider) Finish */:
        return <Step4 />;
      // case 7 /* Get Email Address */:
      //   return <EmailStep5 />;
      default:
        return null;
    }
  };

  const renderLiveChatSteps = (currentStep: number | null) => {
    switch (currentStep) {
      case 1:
        return <LiveChatStep1 />;
      case 2 /* Add Users */:
        return <Step3 />;
      case 3 /* Add Users */:
        return <EmailStep5 />;
      case 4 /* Finish */:
      default:
        return null;
    }
  };

  const renderVoiceCallSteps = (currentStep: number | null) => {
    switch (currentStep) {
      case 1:
        return <VoiceStep1 />;
      case 2:
        return <VoiceStep2 />;
      case 3:
        return <Step4 />;
      default:
        return null;
    }
  };
  useEffect(() => {
    handleMicrosoftAuthRedirect();
  }, [handleMicrosoftAuthRedirect]);

  return (
    <Card sx={{ m: 2, px: 2, py: 5 }}>
      <Grid container spacing={3} justifyContent="space-between">
        <Grid size={{ xs: 12, md: 3 }}>
          <Card sx={{ p: 4 }}>
            <ChannelSteps
              steps={steps(t)}
              activeStep={activeStep ?? 0}
              channelState={channelState}
            />
          </Card>
        </Grid>
        <Grid size={{ xs: 12, md: 9 }}>
          <Card sx={{ height: '100%', p: 3 }}>
            <Typography variant="h6" sx={{ mb: 3 }}>
              {handleStepHeader() ?? ''}
            </Typography>
            <>
              {activeStep === 0 && <Step1 />} {/* Choose Provider */}
              {/* WHATSAPP */}
              {channelType === 'WHATSAPP' && activeStep === 1 && <Step2 />} {/* Create Channel */}
              {channelType === 'WHATSAPP' && activeStep === 2 && <Step3 />} {/* Add Users */}
              {channelType === 'WHATSAPP' && activeStep === 3 && <Step4 />} {/* Finish */}
              {/* EMAIL */}
              {channelType === 'EMAIL' && renderEmailSteps(activeStep)}
              {/* LIVE CHAT */}
              {channelType === 'LIVE_CHAT' && renderLiveChatSteps(activeStep)}
              {/* VOICE CALL */}
              {channelType === 'VOICE' && renderVoiceCallSteps(activeStep)}
            </>
          </Card>
        </Grid>
      </Grid>
    </Card>
  );
}
